import {ThunkDispatch} from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import {connect, useDispatch } from "react-redux"
import { useEffect, useState } from "react";
import { Dropdown } from "flowbite-react";
import {currentUserActions} from '../reducers/currentUser'
import {HamburgerIcon, LogoutIcon} from './SVGIcons'
import MyPageModal from './mypage/MyPageModal'
import Logo from '../../assets/images/logo.svg'
import { RoleTypeExtension, PlanTypeExtension } from '../constants'

// ローカル環境かどうかを判定
const isLocalEnv = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

function mapStateToProps(state: any) {
  return { ...state.currentUser }
}

const CustomerNavBar = (props: any) => {
  const {userName, creditConsumed, creditLimit, isLimitInfinity, planType, roleType} = props
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const [showMyPageModal, setShowMyPageModal] = useState(false);
  const [dropdownOpened, setDropdownOpened] = useState(false);

  // GMOサイバーセキュリティ サイトシールのスクリプト読み込み（ドロップダウンが開かれた後）
  useEffect(() => {
    if (isLocalEnv || !dropdownOpened) return;

    // ドロップダウンが開かれてimg要素がDOMに存在することを確認してからスクリプトを読み込む
    const timer = setTimeout(() => {
      const imgElement = document.getElementById('csi_siteseal_image');
      if (imgElement) {
        const script = document.createElement("script");
        script.src = "https://gmo-cybersecurity.com/siteseal/siteseal.js";
        document.body.appendChild(script);
      }
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [dropdownOpened]);

  const signOutUser = () => {
    dispatch(currentUserActions.signOutUser(navigate))
  }

  // DEBUG ユーザ名クリック時の動作
  const handleUserClick = () => {
    alert('デバッグ：ユーザ名（' + userName + '）が押されました');
  }

  // マイページ設定モーダル表示
  const handleMyPageClick = () => {
    setShowMyPageModal(true);
  }

  // TODO DEBUG 通知アイコン未実装（通知アイコンクリック時のポップアップ）
  const handleNotificationClick = () => {
    alert('デバッグ：通知アイコンが押されました');
  }
  
  return (
    <>
      <header
        className="sticky top-0 z-40 w-full backdrop-blur flex-none transition-colors duration-500 lg:z-50 lg:border-b lg:border-slate-900/10 bg-white supports-backdrop-blur:bg-white/95">
        <div
          className="max-w-8xl mx-auto py-4 border-b border-slate-900/10 lg:px-8 lg:border-0 mx-4 lg:mx-0 flex items-center h-14">
          <div className="flex gap-2 items-center">
            <h1>
              <a href="#"><img src={Logo} alt="" className="max-h-10"/></a>
            </h1>
          </div>
          <div className="px-6">
            <p className="text-blue-600 text-sm ms-4">
              <strong>
                {isLimitInfinity
                  ? `実行回数 ${creditConsumed}回/上限なし(アカウントのクレジット上限)`
                  : `実行回数（残り${creditLimit - creditConsumed}回/${creditLimit}回）`
                }
              </strong>
            </p>
            <p className="text-blue-600 text-sm ms-4">※最新ではない可能性がございます。</p>
          </div>

          <div className="flex ml-auto absolute top-2 right-[2rem]">
            <nav>
              <div className="flex items-center mx-auto">
                {PlanTypeExtension.isEnterprise(planType) && RoleTypeExtension.isAdmin(roleType) && (
                  <button
                    type="button"
                    onClick={() => navigate('/general-user-manage')}
                    className="mr-4 px-3 py-2 text-sm text-gray-700 hover:text-blue-700 hover:underline"
                  >
                    管理画面に移動する
                  </button>
                )}
                <Dropdown label="" renderTrigger={() => (
                  <button type="button"
                    onMouseDown={() => setDropdownOpened(true)}
                    className="inline-flex items-center p-2 h-10 justify-center text-sm text-gray-500 rounded-lg hover:bg-gray-100">
                    {planType && <span className="mr-2 px-2 py-1 text-xs font-semibold text-white bg-orange-500 rounded-full">{planType}プラン</span>}
                    <span className="mr-2">{userName}</span><HamburgerIcon />
                  </button>
                )}>
                  <div
                    className="absolute right-[-1.9rem] top-0 min-w-64 p-4 border border-gray-100 rounded-b-lg bg-gray-50 flex flex-col min-h-[15rem] drop-shadow-md">
                    <ul
                      className="font-medium flex flex-col gap-2 lg:border-b lg:border-slate-900/10 mb-2 pb-2">
                      <li>
                        <a href="#" onClick={handleMyPageClick}
                          className="flex py-2 px-3 rounded text-gray-900 hover:text-blue-700 hover:bg-gray-100 hover:underline">マイページ設定</a>
                      </li>
                      <li>
                        <a target="_blank" rel="noopener noreferrer" href="https://spectrum-shelf-ea1.notion.site/292c7ec93b1b806eb105fc3f4f9ec0a1"
                          className="flex py-2 px-3 rounded text-gray-900 hover:text-blue-700 hover:bg-gray-100 hover:underline">操作マニュアル</a>
                      </li>
                      <li>
                        <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSeOnqLutSGFjjvo6Bo0Z9Ulq4vb6tcH8pGA0m39kxA9Z1xAVg/viewform"
                          className="flex py-2 px-3 rounded text-gray-900 hover:text-blue-700 hover:bg-gray-100 hover:underline">お問い合わせ</a>
                      </li>
                      <li>
                        <a target="blank" href="/static/docs/term_of_use.pdf"
                          className="flex py-2 px-3 rounded text-gray-900 hover:text-blue-700 hover:bg-gray-100 hover:underline">利用規約</a>
                      </li>
                      <li>
                        <a target="blank" href="/static/docs/policy.pdf"
                          className="flex py-2 px-3 rounded text-gray-900 hover:text-blue-700 hover:bg-gray-100 hover:underline">プライバシーポリシー</a>
                      </li>
                    </ul>
                    <a href="#" onClick={signOutUser}
                    className="flex py-2 px-3 rounded text-gray-900 hover:bg-gray-100 mt-auto gap-1 items-center">
                    <LogoutIcon />
                    ログアウト</a>
                    {/* GMOサイバーセキュリティ サイトシール */}
                    <div className="border-t border-slate-900/10 mt-3 pt-3 mb-2">
                      <span
                        id="csi_siteseal_tag"
                        onContextMenu={(e) => e.preventDefault()}
                        className="flex justify-center"
                        style={{width: '130px', height: '66px', margin: '0 auto'}}
                      >
                        {/* ローカル環境用プレースホルダー */}
                        {isLocalEnv && (
                          <div
                            className="flex items-center justify-center bg-gray-100 border border-gray-300 rounded text-xs text-gray-500"
                            style={{width: '130px', height: '66px'}}
                          >
                            サイトシール
                          </div>
                        )}
                        {/* 本番環境用 */}
                        {!isLocalEnv && (
                          <a id="csi_siteseal_profile_link">
                            <img
                              id="csi_siteseal_image"
                              alt="dark_typeA_130x66.png"
                              width="130"
                              height="66"
                              style={{display: 'none'}}
                            />
                          </a>
                        )}
                      </span>
                    </div>
                  </div>
                </Dropdown>
              </div>
            </nav>
          </div>
        </div>
      </header>

      {/* マイページモーダル */}
      {showMyPageModal && (
        <MyPageModal onClose={() => setShowMyPageModal(false)} />
      )}
    </>
  )
};

export default connect(mapStateToProps)(CustomerNavBar)